import React from "react";
import { errorsCopy } from "./errorsCopy";

export const createCause = (selectedRow: any) => {
  if (selectedRow.error_type === "connectivity") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.connectivity_default_cause;
  }
  if (selectedRow.error_type === "image_quality") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.image_quality_default_cause;
  }
  if (selectedRow.error_type === "stream_quality") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.stream_quality_default_cause;
  }
  if (selectedRow.error_type === "motion_status") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.motion_status_default_cause;
  }
  if (selectedRow.error_type === "recording_status") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.recording_status_default_cause;
  }
  if (selectedRow.error_type === "scene_change") {
    if (selectedRow.likely_cause) {
      return selectedRow.likely_cause;
    } else return errorsCopy.scene_change_default_cause;
  }
};
